<template>
  <div class="apartment-socials-container mobile-social hidden-sm-and-up">
    <el-button
      :class="{ active: socialsBtnActive }"
      class="apartment-add-to-selected-btn"
      type="text"
      @click="socialLinks = true"
      ><IconBase height="16" width="16"> <Share /> </IconBase
    ></el-button>
    <el-dialog :visible.sync="socialLinks" width="90%" center top="50vh">
      <div class="mobile-write-sellers">Поділитись</div>
      <div>
        <div class="seller-socials-container mobile-socials">
          <ul class="socials-container White-colored Small">
            <li class="socials-item">
              <a
                class="socials-item-icon-container"
                :href="'viber://forward?text=' + flatLink"
                target="_blank"
              >
                <IconBase height="16" width="16">
                  <ViberColored />
                </IconBase>
              </a>
            </li>
            <li class="socials-item">
              <a
                class="socials-item-icon-container"
                :href="'https://t.me/share/url?url=' + flatLink"
                target="_blank"
              >
                <IconBase height="16" icon-color="#0088CC" width="16">
                  <TelegramBlack />
                </IconBase>
              </a>
            </li>
            <li class="socials-item">
              <button
                class="socials-item-icon-container"
                type="button"
                @click="noticeLinkCopy"
              >
                <IconBase height="16" icon-color="#016BF3" width="16">
                  <Link />
                </IconBase>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <div :class="{ active: true }" class="apartment-link-copy">
      <span>Посилання скопійовано</span>
    </div>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Link from '@/components/icons/Link'
import InstagramColored from '@/components/icons/InstagramColored'
import FacebookBlack from '@/components/icons/FacebookBlack'
import TelegramBlack from '@/components/icons/TelegramBlack'
import ViberColored from '@/components/icons/ViberColored'
import Share from '@/components/icons/Share'
export default {
  name: 'ApartmentSocialMobile',
  props: ['id'],
  components: {
    IconBase,
    Link,
    InstagramColored,
    FacebookBlack,
    TelegramBlack,
    ViberColored,
    Share,
  },
  data() {
    return {
      linkCopied: false,
      socialLinks: false,
      socialsBtnActive: false,
      flatLink: window.location.origin + '/flat-detail/' + this.id,
    }
  },
  methods: {
    noticeLinkCopy() {
      this.copyFlatLink()
      this.$successMessage('Посилання скопійовано', '', 'shareNotification')
    },
    copyFlatLink() {
      this.$copyText(this.flatLink)
      this.hide()
    },
    toggle() {
      if (this.socialLinks) {
        return this.hide()
      }
      return this.show()
    },
    show() {
      this.socialLinks = true
      this.socialsBtnActive = true
      setTimeout(() => document.addEventListener('click', this.hide), 0)
    },
    hide() {
      this.socialLinks = false
      this.socialsBtnActive = false
      document.removeEventListener('click', this.hide)
    },
  },
}
</script>

<style lang="scss">
.apartment-socials-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  .socials-container {
    margin-right: 1rem;
  }

  .apartment-link-copy {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    right: -5.6rem;
    transform: translateX(100%);
    min-width: 28.5rem;
    max-width: 28.5rem;
    padding: 1.6rem 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    font-family: Nunito-Regular, sans-serif;
    font-size: 1.4rem;
    color: #4d4d4f;
    border-radius: 1rem;
    background-color: #fff;

    &.active {
      opacity: 1;
    }
  }
}

.socials-link-container__Shown {
  .socials-container {
    flex-direction: column;
    align-items: flex-start;

    .socials-item {
      &:not(:last-child) {
        margin-bottom: 1rem;
        margin-right: 0;
      }
    }
  }

  &.el-popover {
    min-width: 3rem;
    padding: 1rem 0 1rem 1rem;
  }
}

.socials-link-container__notShown {
  &.el-popover {
    box-shadow: unset;
    border: none;

    .popper__arrow {
      display: none;
    }
  }
}

@media (max-width: 500px) {
  .apartment-socials-container.mobile-social {
    top: -7px;
    left: 7px;
  }
}
</style>
